import * as XLSX from 'xlsx';

export const downloadCSV = (results, batchId) => {
  if (!results || results.length === 0) {
    console.error('No results to export');
    return;
  }

  // Define the maximum length for each cell
  const MAX_CELL_LENGTH = 32767;

  // Prepare the data for Excel and truncate long values
  const truncateValue = (value) => {
    if (value == null) return ''; // Handle null/undefined
    const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
    return stringValue.length > MAX_CELL_LENGTH
      ? stringValue.slice(0, MAX_CELL_LENGTH - 3) + '...' // Truncate and add ellipsis
      : stringValue;
  };

  const worksheetData = results.map((result) =>
    Object.fromEntries(
      Object.entries(result._originalRow).map(([key, value]) => [key, truncateValue(value)])
    )
  );

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // Create a workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Results');

  // Generate the Excel file and trigger download
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `batch_${batchId}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};